import {BusinessCaseResponseBody} from '@dms/api/finance';

export const getPurchaseVehicleIdFromBusinessCase = (
  businessCase: BusinessCaseResponseBody | undefined
) =>
  businessCase?.businessCaseInternalType === 'PURCHASE_BROKERAGE'
    ? (businessCase?.offers?.[0]?.purchaseBrokerageVehicles?.[0]?.vehicleId ?? null)
    : (businessCase?.offers?.[0]?.purchaseVehicles?.[0]?.vehicleId ?? null);
